import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function RepairGarage({
  color = 'icon.primary',
  strokeWidth = 6,
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 100 96' {...props}>
      <Path
        d='M31.7018 20.0164H48.9444'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M33.4711 42.8359H19.7792V74.7837'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M19.78 74.7933H1.52411L1.52173 18.4238C1.52173 15.2926 3.21996 12.4078 5.9579 10.8887L36.1326
        1.76323C40.2993 -0.516099 44.8613 1.76235 44.5075 1.76323L74.6775 10.8887C77.413 12.4097 79.1091
        15.2939 79.1091 18.4238L79.1115 29.1537'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M92.8213 69.2998C92.8213 64.2586 88.7346 60.1719 83.6934 60.1719H47.1816C42.1404 60.1719
        38.0537 64.2586 38.0537 69.2998'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M38.0537 69.3203V83.925C38.0537 86.4456 40.0971 88.489 42.6177 88.489H47.136C49.6566 88.489
        51.7 86.4456 51.7 83.925V80.9082H79.175V83.925C79.175 86.4456 81.2184 88.489 83.739 88.489H88.2573C90.7779
        88.489 92.8213 86.4456 92.8213 83.925V69.3203'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M55.0885 70.6976H48.2609'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M82.5682 70.6976H75.7405'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M85.9817 59.9033L92.8094 56.4918'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M44.9042 59.9037L38.0537 56.4922'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M54.3519 42.8359C51.184 42.8439 48.4354 45.0243 47.7068 48.1073L44.8132 60.4757L47.7068
        48.1073C48.4354 45.0243 51.184 42.8439 54.3519 42.8359H76.551C79.7189 42.8439 82.4676 45.0243
        83.1962 48.1073L86.0897 60.4757'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

RepairGarage.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default RepairGarage
